export enum LeftNavSection {
  None = "None",
  MobilyticsVisitors = "MobilyticsVisitors",
}
